/**
 * pallete for theme
 */
const customPalette = Object.freeze({
  primary: {
    main: '#005E47',
    light: '#00A77E',
  },
  secondary: {
    main: '#BE1D3F',
    light: '#EF4060',
  },
  background: {
    main: '#F4F6F7',
    light: '#FFFFFF',
    lightGrey: 'rgba(244, 246, 247, 1)',
    lightGreen: '#BBE3DA',
    lightPink: '#FBD4D5',
  },
  accent: {
    darkGreen: '#00362F',
    paleGreen: '#8DD1C1',
    paleRed: '#F37E90',
    darkOrange: '#A45E0A',
    lightGrey: '#546366',
  },
  text: {
    primary: '#000000',
    secondary: '#FFFFFF',
  },
  action: {
    disabled: '#000000',
  },
  highlight: {
    primary: '#BAD7FB',
  },
  hover: {
    main: '#0C8671',
  },
  grey: {
    extraLight: '#E4E9EC',
    light: '#C5CED1',
    medium: '#546366',
    dark: '#2A393E',
  },
})

export default customPalette
